
import { ActionResult } from "data/StepWithAction";
import { isFieldsNotEmpty } from "functions/isFieldsNotEmpty";

import { MultiPageGuideCollection } from "../MultiPageGuideCollection";
import { SinglePageGuideCollection } from "../SinglePageGuideCollection";

import { EditorInterface, TourContext } from "./TourContext";

const tourContext: TourContext<EditorInterface> = window as any as TourContext<EditorInterface>;

const Step1CreateDocument: SinglePageGuideCollection = {
    stageNumber: 1,
    cookieName: 'team-efficiency-guide-stage-1',
    navigateTo: '/documents/edit/new',
    steps: [
        {
            title: 'Welcome to The Article Editor!',
            tooltipClass: 'lg',
            intro: `
            <img src="/team-efficiency-starter.gif" alt="intro gif" style="max-width: 100%" /><br />
            This is where the magic begins!
            `,
        },
        {
            element: '.headline-textbox',
            intro: 'To get started, enter a title for your article.',
            position: 'bottom-middle-aligned',
            isActionCompleted: (): ActionResult => isFieldsNotEmpty(['.headline-textbox'], 'You must enter a headline to continue!')
        },
        {
            element: '.short-description',
            intro: 'Then, enter a brief description here.',
            position: 'bottom-middle-aligned',
        },
        {
            element: '.image-label-container',
            intro: 'Next, upload a cover image.',
            position: 'top',
        },
        {
            element: '.doc-tabs',
            intro:
                'Change tabs to edit secondary info such as the publication date, the blog post category, and social media posts for the article.',
            position: 'top',
        },
        {
            element: '.rich-editor',
            intro: 'This is your distraction free writing surface, where your masterpiece comes to life!',
            position: 'right',
            isActionCompleted: (): ActionResult => {
                const content = tourContext.args.articleEditor!.app.editor.getContent();
                const isCompleted = content && content.trim() !== '';
                return { isCompleted, message: "You must enter some content to proceed." }
            }
        },
        {
            element: '.ai-writing-tab',
            intro: 'Prompt Chains are your <i class="bi bi-magic"></i> magic wand helping you generate masterpieces!  Click <strong>Run</strong> on any prompt chain to start generating content!  Click <strong>Details</strong> to look under the hood, and start customizing prompt templates.',
            position: 'left',
        },
        {
            element: '.editor-sidebar',
            intro: 'Later, when reviewers leave comments on your work, you will see them under the <strong>Activity</strong> tab.',
            position: 'left',
        },
        {
            element: '#btnSendForReview',
            intro: "Finally, send your article to the configured project approvers by clicking <strong>Send for Review</strong>!",
            position: 'top',
            tooltipClass: 'button-overlay',
            isActionCompleted: (): ActionResult => {
                const isCompleted = tourContext.args.isDocumentSubmitted ?? false;
                return {
                    isCompleted,
                    message: 'You must "send for review" in order to proceed.'
                }
            }
        }
    ]
}

const Step2ReviewDocument: SinglePageGuideCollection = {
    stageNumber: 2,
    cookieName: 'team-efficiency-guide-stage-1',
    navigateTo: '/documents/view/:documentId',
    steps: [
        {
            title: 'Approval Workflow',
            tooltipClass: 'xl',
            intro: `
            <div class="row">
                <div class="col">
                    <img src="/approver-welcome.png" alt="intro gif" style="max-width: 100%" />
                </div>
                <div class="col">
                    <p>Next the configured <strong>approvers</strong> will receive an email notification that a document is ready for review.</p>
                    <p>They can also navigate to the documents list and click on the view (<i class="bi bi-eye"></i>) icon to review the document.</p>
                </div>
            </div>
            `,
        },
        {
            element: '.ViewDocument',
            intro: "Here they can review the article, corresponding social posts, and other metadata.  ",
            position: 'top',
        },
        {
            element: '.action-button-wrapper',
            intro: 'They can easily <strong>approve</strong>, <strong>reject</strong>, or directly <strong>edit</strong> the article.'
        },
        {
            intro: `
            To learn more about the automated workflow process within BlabberJax, 
            <a href="https://blabberjax.atlassian.net/wiki/x/AQCFGQ" target="_blank">click here</a>!`
        },

    ]
}

export const TeamEfficiencyGuideKey = "team-efficiency-guide-1";

const teamEfficiencyGuidesCollection: MultiPageGuideCollection = {
    title: 'Team Efficiency Guide',
    key: TeamEfficiencyGuideKey,
    steps: [
        Step1CreateDocument,
        Step2ReviewDocument
    ],
    onCompleteNavigateTo: '/documents/edit/new'
};

export default teamEfficiencyGuidesCollection